<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN -->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="cinema-mode" *ngIf="translations && globalUserPreferencesParams?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar>
        <ng-template class="p-grid" pTemplate="left">
            <div class="p-col-12 p-md-12 p-sm-2">
                <!-- Botón de Regresar -->
                <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                    class="p-button-warning p-mr-2 p-mb-2" (click)="goBack()"></button>

                <!-- Botón de Descargar -->
                <button pButton type="button" [label]="blockedButton ? 'Descargando ...' : 'Descargar'"
                    class="p-button-success p-mr-2 p-mb-2"
                    [disabled]="blockedButton || blockedButton360fps || blockedButton720fps" (click)="downloadVideo()">
                </button>

                <!-- Botón de Descargar en 360fps -->
                <button *ngIf="this.downloadCdnVideo360" pButton type="button"
                    [label]="blockedButton360fps ? 'Descargando ...' : '360fps'" class="p-button-success p-mr-2 p-mb-2"
                    [disabled]="blockedButton || blockedButton360fps || blockedButton720fps"
                    (click)="downloadVideo360()">
                </button>

                <!-- Botón de Descargar en 720fps -->
                <button *ngIf="this.downloadCdnVideo720" pButton type="button"
                    [label]="blockedButton720fps ? 'Descargando ...' : '720fps'" class="p-button-success p-mr-2 p-mb-2"
                    [disabled]="blockedButton || blockedButton360fps || blockedButton720fps"
                    (click)="downloadVideo720()">
                </button>
            </div>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-grid">
                    <div class="p-col-6 p-md-6">
                        <span>Guía</span>
                    </div>
                    <div class="p-col-6 p-md-6">
                        <span class="p-text-bold">{{ globalUserDataFormParams.get('selectedGuide')?.value || 'No
                            seleccionado' }}</span>
                    </div>
                </div>

                <div class="p-grid">
                    <div class="p-col-6 p-md-6">
                        <span>Zona</span>
                    </div>
                    <div class="p-col-6 p-md-6">
                        <span class="p-text-bold">{{ globalUserDataFormParams.get('selectedCoordination')?.value || 'No
                            seleccionado' }}</span>
                    </div>
                </div>

                <div class="p-grid">
                    <div class="p-col-6 p-md-6">
                        <span>Nacional</span>
                    </div>
                    <div class="p-col-6 p-md-6">
                        <span class="p-text-bold">{{ globalUserDataFormParams.get('selectedCoordination')?.value || 'No
                            seleccionado' }}</span>
                    </div>
                </div>

                <div class="p-grid">
                    <div class="p-col-6 p-md-6">
                        <span>Lenguaje</span>
                    </div>
                    <div class="p-col-6 p-md-6">
                        <span class="p-text-bold">{{ globalUserDataFormParams.get('selectedLanguage')?.value?.value ||
                            'No seleccionado' }}</span>
                    </div>
                </div>

                <div class="p-grid">
                    <div class="p-col-6 p-md-6">
                        <span>Nombre</span>
                    </div>
                    <div class="p-col-6 p-md-6">
                        <span class="p-text-bold">{{ name ||
                            'No seleccionado' }}</span>
                    </div>
                </div>
            </p-panel>
        </div>
    </div>

    <!-- VIDEO PLAYER -->
    <div class="video-wrapper">
        <iframe [src]="vimeoUrl" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
    </div>
</div>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferencesParams?.storeId == null" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta más tarde...</span>
</div>